import React from 'react';
import { Dialog, Button } from 'day8-ui';
import { useToolipModal } from '../context/TooltipModalContext';

const TooltipModal = () => {
  const { modalProps, isModalOpen, close } = useToolipModal();
  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={close}
      scrollable
      showFooter
      footerComponent={<Button className='dui-w-full' onClick={close}>Close</Button>}
    >
      <h2 className='dui-text-2xl dui-mb-4'>{modalProps?.title}</h2>
      {modalProps?.tooltipText}
    </Dialog>
  );
};
export default TooltipModal;